<template>
  <div class="main-container">
    <div class="title-container">
      <span class="inner-title-container">
        <span class="title">Welcome to</span>
        <span class="title">{{ currentCircle.condition_type }}{{ !currentCircle.condition_type.toLowerCase().includes("circle") ? " Circle" : "" }}</span>
      </span>
    </div>
    <span class="instruction">Please select the role you want to participate as.</span>
    <div class="claimed-container">
      <div class="sub-container" v-for="(item, index) in availableRoles" v-if="!ClaimedRoles.includes(item.tag)" :key="index">
        <div class="container">
          <hr class="vert-divider" />
          <div class="right-container">
            <img class="icon" :src="item.icon" alt="icon" />
            <div class="text-container tool-tip">
              <div v-if="item.tag === 'patient'">
                <span class="text"
                  >{{ item.des }}
                  <span class="text" style="text-transform: capitalize">
                    {{
                      currentCircle.condition_type
                        .toLowerCase()
                        .replace("circle", "")
                        .replace("my", "")
                    }}
                  </span>
                </span>
              </div>
              <div v-else>
                <span class="text">{{ item.des }}</span>
              </div>
              <a-tooltip :trigger="[onClickToolTip ? 'click' : 'hover']" :getPopupContainer="trigger => trigger.parentNode" :overlayStyle="{ width: '200px' }" arrow-point-at-center>
                <template #title>
                  {{
                    item.tag === "patient"
                      ? `Is a participant with the condition.`
                      : item.tag === "caregiver"
                      ? "Is a participant who is authorized to represent a child under 18 or a patient who is unable to represent himself/herself due to health issues."
                      : item.tag === "advocate"
                      ? "Is a participant who represents himself/herself as he/she cares about the mission or is authorized to represent an associated non-for-profit organization."
                      : null
                  }}
                </template>
                <img class="question-icon" src="../../assets/images/question-mark.png" alt="questionIcon" />
              </a-tooltip>
            </div>
          </div>
          <div class="btn-container">
            <a-button
              class="joinCircle-bttn join-button"
              id="join"
              :style="[{ background: getPrimaryColor() }]"
              :loading="activeTag === item.tag ? isPageRouting : false"
              @click="goToNext(item.tag, $event)"
            >
              Join Circle
            </a-button>
          </div>
        </div>
      </div>
      <div class="sub-container" v-for="(item, index) in ClaimedRoles" :key="index">
        <div class="container">
          <hr class="vert-divider" />
          <div class="right-container">
            <a-avatar
              :style="{
                color: ' #ffffff !important',
                'background-color': item.picture ? '' : '#EF8585',
                display: 'flex',
                'align-items': 'center',
                'max-width': '70px',
                width: '100%',
                height: '70px',
              }"
              :src="item.picture"
              class="text-capitalize"
            >
              {{ item.display_name[0] }}
            </a-avatar>
            <div class="text-container1">
              {{ item.display_name }}
              <div :class="blue.includes(item.role) ? 'patient-tag-mob' : 'physician-tag-mob'" :style="{ background: blue.includes(item.role) ? getPrimary50Color() : '#FFF0D6' }">
                <span v-if="item.role === 'patient'"><font-awesome-icon class="tag-icon-blue" :style="{ color: getPrimaryColor() }" :icon="['far', 'user']" /> </span>
                <span v-if="item.role === 'caregiver'"><img class="tag-icon-blue" :style="{ color: getPrimaryColor() }" src="../../assets/handsholdingheart.svg" alt="RoleIcon"/></span>
                <span v-if="item.role === 'advocate'"><font-awesome-icon class="tag-icon-blue" :style="{ color: getPrimaryColor() }" :icon="['far', 'bullhorn']" /> </span>
                <span v-if="item.role === 'doctor'"><img class="tag-icon-oran" src="../../assets/userdoctor-orange-tag.svg" alt="RoleIcon"/></span>
                <span v-if="item.role === 'hospital_administrator'"><img class="tag-icon-oran" src="../../assets/hospital-wide-orange-tag.svg" alt="RoleIcon"/></span>
                <span v-if="item.role === 'clinic_administrator'"><img class="tag-icon-oran" src="../../assets/hospital-orange-tag.svg" alt="RoleIcon" /> </span>
                <span v-if="item.role === 'nfp_administrator'"><font-awesome-icon class="tag-icon-oran" :icon="['far', 'hand-holding-heart']" /> </span>
                <span v-if="item.role === 'business_administrator'"><img class="tag-icon-oran" src="../../assets/buisness.svg" width="10" height="12" :style="{ fill: '#F5A623' }"/></span>
                <span v-if="item.role === 'hcp'"><font-awesome-icon class="tag-icon-oran" :icon="['far', 'user-nurse']" /> </span>
                <span :class="blue.includes(item.role) ? 'blue-text' : 'yellow-text'">
                  {{
                    item.role === "doctor"
                      ? "Physician"
                      : item.role === "hospital_administrator"
                      ? "Hospital"
                      : item.role === "clinic_administrator"
                      ? "clinic"
                      : item.role === "nfp_administrator"
                      ? "Non-For-Profit"
                      : item.role === "hcp"
                      ? "Advanced Medical Professional"
                      : item.role === "business_administrator"
                      ? "Business"
                      : item.role
                  }}
                </span>
              </div>
            </div>
          </div>
          <div :class="blue.includes(item.role) ? 'patient-tag' : 'physician-tag'" :style="{ background: blue.includes(item.role) ? getPrimary50Color() : '#FFF0D6' }">
            <span v-if="item.role === 'patient'"><font-awesome-icon class="tag-icon-blue" :style="{ color: getPrimaryColor() }" :icon="['far', 'user']" /> </span>
            <span v-if="item.role === 'caregiver'"><img class="tag-icon-blue" :style="{ color: getPrimaryColor() }" src="../../assets/handsholdingheart.svg" alt="RoleIcon"/></span>
            <span v-if="item.role === 'advocate'"><font-awesome-icon class="tag-icon-blue" :style="{ color: getPrimaryColor() }" :icon="['far', 'bullhorn']" /> </span>
            <span v-if="item.role === 'doctor'"><img class="tag-icon-oran" src="../../assets/userdoctor-orange-tag.svg" alt="RoleIcon"/></span>
            <span v-if="item.role === 'hospital_administrator'"><img class="tag-icon-oran" src="../../assets/hospital-wide-orange-tag.svg" alt="RoleIcon"/></span>
            <span v-if="item.role === 'clinic_administrator'"><img class="tag-icon-oran" src="../../assets/hospital-orange-tag.svg" alt="RoleIcon" /> </span>
            <span v-if="item.role === 'nfp_administrator'"><font-awesome-icon class="tag-icon-oran" :icon="['far', 'hand-holding-heart']" /> </span>
            <span v-if="item.role === 'hcp'"><font-awesome-icon class="tag-icon-oran" :icon="['far', 'user-nurse']" /> </span>
            <span v-if="item.role === 'business_administrator'"><img class="tag-icon-oran" src="../../assets/buisness.svg" width="10" height="12" :style="{ fill: '#F5A623' }"/></span>
            <span :class="blue.includes(item.role) ? 'blue-text' : 'yellow-text'">
              {{
                item.role === "doctor"
                  ? "Physician"
                  : item.role === "hospital_administrator"
                  ? "Hospital"
                  : item.role === "clinic_administrator"
                  ? "clinic"
                  : item.role === "nfp_administrator"
                  ? "Non-For-Profit"
                  : item.role === "hcp"
                  ? "Advanced Medical Professional"
                  : item.role === "business_administrator"
                  ? "Business"
                  : item.role
              }}
            </span>
          </div>
          <div class="btn-container">
            <a-button
              class="joinCircle-bttn join-button"
              :style="[{ background: getPrimaryColor() }]"
              id="Enter"
              :loading="activeTag === item.role ? isPageRouting : false"
              @click="goToNext(item.role, $event)"
            >
              Join Circle
            </a-button>
          </div>
        </div>
      </div>
    </div>
    <div class="divider">Check other roles you can enter the Circle as.</div>
    <div class="divider-mob">Check other roles you can enter the Circle as.</div>
    <div class="claim-container">
      <div class="sub-container" v-for="(item, index) in ClaimRoles" v-if="!roles.includes(item.tag)" :key="index">
        <div class="container">
          <hr class="vert-divider2" />
          <div class="right-container">
            <img class="icon" :src="item.icon" alt="icon" />
            <div class="text-container tool-tip">
              <span class="text">{{ item.des }}</span>
              <a-tooltip :trigger="[onClickToolTip ? 'click' : 'hover']" :getPopupContainer="trigger => trigger.parentNode" :overlayStyle="{ width: '200px' }" arrow-point-at-center>
                <template #title>
                  {{
                    item.tag === "doctor"
                      ? "Is a US-based (board-certified) physician who is qualified to practice medicine."
                      : item.tag === "hospital_administrator"
                      ? "Is an authorized person responsible for carrying out the administration of a hospital."
                      : item.tag === "clinic_administrator"
                      ? "Is an authorized person responsible for carrying out the administration of a clinic."
                      : item.tag === "nfp_administrator"
                      ? "Is an authorized person responsible for carrying out the administration of a non-for-profit organization."
                      : "Is a US-based qualified medical practitioner who is involved in related healthcare services."
                  }}
                </template>
                <img class="question-icon" src="../../assets/images/question-mark.png" alt="questionIcon" />
              </a-tooltip>
            </div>
          </div>
          <div class="btn-container">
            <a-button
              :class="ClaimedRoles.includes(item.tag) ? 'enter-bttn enter-button' : 'claim-bttn join-button'"
              :loading="activeTag === item.tag ? isPageRouting : false"
              v-bind:style="[ClaimedRoles.includes(item.tag) ? { background: getSecondaryColor() } : { background: getPrimaryColor() }]"
              :id="ClaimedRoles.includes(item.tag) ? 'Enter' : 'claim'"
              @click="goToNext(item.tag, $event)"
            >
              {{ ClaimedRoles.includes(item.tag) ? "Enter" : "Claim My Profile" }}
            </a-button>
          </div>
        </div>
      </div>
    </div>
    <AddAdvocateModal ref="AddAdvocateModal" />
    <Footer class="w-100 mt-5" />
  </div>
</template>

<script>
import AddAdvocateModal from "../Modals/AddAdvocateModal.vue"
const svg1 = require("../../assets/icon-check-badge.svg")
const svg2 = require("../../assets/icon-uncheck-badge.svg")
const default_img = require("../../assets/images/icon_profile.svg")
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import Footer from "../App/FooterGeneric.vue"

const AppRepository = RepositoryFactory.get("app")
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "UserType",

  props: {
    msg: String,
  },

  components: {
    AddAdvocateModal,
    Footer,
  },
  data() {
    return {
      activeTag: "",
      disabled: true,
      userTypeSelect: "",
      userProfession: "",
      options1: [
        { key: "", value: "Anesthesiology Assistant" },
        { key: "", value: "Certified Clinical Nurse Specialist (CNS)" },
        { key: "", value: "Certified Nurse Midwife (CNM)" },
        { key: "", value: "Certified Registered Nurse Anesthetist (CRNA)" },
        { key: "", value: "Chiropractic" },
        { key: "", value: "Clinical Social Worker" },
        { key: "", value: "Nurse Practitioner" },
        { key: "", value: "Occupational Therapy" },
        { key: "", value: "Optometry" },
        { key: "", value: "Physical Therapy" },
        { key: "", value: "Physician Assistant" },
        { key: "", value: "Clinical Psychologist" },
        { key: "", value: "Qualified Audiologist" },
        { key: "", value: "Qualified Speech Language Pathologist" },
        { key: "", value: "Registered Dietitian or Nutrition Professional" },
      ],
      options2: [
        { key: "hospital", value: "Hospital Administrator" },
        { key: "clinic", value: "Clinic Administrator" },
        { key: "nfc", value: "Non For Profit Administrator" },
      ],
      blue: ["patient", "advocate", "caregiver"],
      activeIcon: null,
      userDetails: null,
      roles: [],
      ClaimedRoles: [],
      availableRoles: [
        {
          tag: "patient",
          des: "I’m a person with ",
          icon: require("../../assets/images/patient.png"),
          tagIcon: require("../../assets/images/patient-tag-icon.png"),
        },
        {
          tag: "caregiver",
          des: "I’m a Caregiver",
          icon: require("../../assets/images/caregiver.png"),
          tagIcon: `<font-awesome-icon class="icon":icon="['fal', 'hand-holding-heart']"/>`,
        },
        {
          tag: "advocate",
          des: "I’m an Advocate",
          icon: require("../../assets/images/advocate.png"),
          tagIcon: require("../../assets/images/advocate-blue.png"),
        },
      ],
      ClaimRoles: [
        {
          tag: "doctor",
          des: "I’m a Physician",
          icon: require("../../assets/images/physician.png"),
          tagIcon: require("../../assets/images/physician-yellow.png"),
        },
        {
          tag: "hospital_administrator",
          des: "I’m Hospital Administrator",
          icon: require("../../assets/images/hospadmin.png"),
          tagIcon: `<font-awesome-icon class="icon":icon="['fal', 'hospital']"/>`,
        },
        {
          tag: "clinic_administrator",
          des: "I’m a Clinic Administrator",
          icon: require("../../assets/images/clinicadmin.png"),
        },
        {
          tag: "nfp_administrator",
          des: "I’m a Non-For-Profit Administrator",
          icon: require("../../assets/images/nfpadmin.png"),
        },
        {
          tag: "hcp",
          des: "I’m an Advanced Healthcare Professional",
          icon: require("../../assets/images/advancedhp.png"),
        },
      ],
      selectedRole: null,
      img1: svg1,
      img2: svg2,
      isPageRouting: false,
      defaultImg: default_img,
      user: {},
      onClickToolTip: false,
      allRolesOrder: ["patient", "caregiver", "advocate", "doctor", "hospital_administrator", "clinic_administrator", "nfp_administrator", "hcp", "ahp"],
    }
  },
  watch: {
    userTypeSelect: function(val) {
      this.disabled = false
    },
  },
  mounted() {
    window.scrollTo(0, 0)
  },

  created() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
    console.warn("SignupUserType.vue is created")
    // this.user = JSON.parse(localStorage.getItem("user-full-info"));
    // console.log(this.user,"user from")

    // if(localStorage.getItem("hospital")==="true"){
    //         this.ClaimedRoles.push("hospital_administrator")
    //     }
    // if(localStorage.getItem("clinic")==="true"){
    //         this.ClaimedRoles.push("clinic_administrator")
    //     }
    //  if(localStorage.getItem("physician")==="true"){
    //     this.ClaimedRoles.push("doctor")
    //  }
    //  if(localStorage.getItem("nfp")==="true"){
    //     this.ClaimedRoles.push("nfp_administrator")
    //  }
    //  if(localStorage.getItem("ohcp")==="true"){
    //     this.ClaimedRoles.push("hcp")
    //  }
    //  console.log(this.ClaimedRoles);
    this.init()
  },

  destroyed() {
    window.removeEventListener("resize", this.handleResize)
  },

  methods: {
    init() {
      AppRepository.getHasMultiRole(this.currentCircle.id).then(res => {
        console.log("get has multi for multiple role", res.data.data)
        this.ClaimedRoles = res.data.data
        this.ClaimedRoles.sort((a, b) => this.allRolesOrder.indexOf(a.role) - this.allRolesOrder.indexOf(b.role))
        this.ClaimedRoles.forEach(item => {
          this.roles.push(item.role)
        })
        console.log(this.ClaimedRoles, "claimedroles")
      })
    },

    handleResize() {
      if (window.innerWidth < 700) {
        this.onClickToolTip = true
      } else {
        this.onClickToolTip = false
      }
    },
    goToNext(tag, event) {
      this.activeTag = tag
      if (event.target.id === "Enter") {
        this.isPageRouting = true
        this.selectedRole = tag
        const payload = { role: this.selectedRole, circle_id: this.currentCircle.id, send_updates: this.$route.query.send_updates === "true" ? true : false }
        this.postRole(payload)
        payload.dtoken = this.authUser.user.dovemed_csrf_token
      } else if (event.target.id === "join") {
        this.isPageRouting = true
        this.$store.commit("Signup/setUserTypeSelection", tag)
        switch (tag) {
          case "patient":
            console.log("goToNext() -> patient case")
            this.$router.push({ name: "UserProfileWelcome", params: { role: tag }, query: { role: tag, send_updates: this.$route.query.send_updates } })
            break
          case "caregiver":
            console.log("goToNext() -> caregiver case")
            this.$router.push({ name: "UserProfileWelcome", params: { role: tag }, query: { role: tag, send_updates: this.$route.query.send_updates } })
            break
          case "advocate":
            this.$router.push({ name: "UserProfileWelcomeAdvocate", params: { role: tag }, query: { role: tag, send_updates: this.$route.query.send_updates } })
            // this.$refs.AddAdvocateModal.showModal(this.currentCircle.id);
            break

          // case "physician":
          //       console.log("tried joining as physician")
          //       this.selectedRole="doctor";
          //       const payload = {
          //       role: this.selectedRole,
          //       circle_id: this.currentCircle.id
          //     };
          //     console.log(payload, "in login");
          //     this.postRole(payload);
          //     payload.dtoken = this.authUser.user.dovemed_csrf_token;
          // break;

          default:
            this.selectedRole = tag
            const payload = { role: this.selectedRole, circle_id: this.currentCircle.id }
            console.log(payload, "in login")
            this.postRole(payload)
            payload.dtoken = this.authUser.user.dovemed_csrf_token
        }
        this.isPageRouting = false
      } else {
        this.isPageRouting = true
        const appName = encodeURIComponent("Claim proccess")
        const currentPath = encodeURIComponent(window.location.href)
        switch (tag) {
          case "doctor":
            window.open(`${process.env.SSO_BASE_URL}/dovemed-sso/claim/physician/?next=${currentPath}`)
            break
          case "hospital_administrator":
            window.open(`${process.env.SSO_BASE_URL}/dovemap?item_type=hospital&appName=${appName}&previous=${currentPath}&claim=true&next=${currentPath}`)
            break
          case "clinic_administrator":
            window.open(`${process.env.SSO_BASE_URL}/dovemap?item_type=clinic&appName=${appName}&previous=${currentPath}&claim=true&next=${currentPath}`)
            break
          case "nfp_administrator":
            window.open(`${process.env.SSO_BASE_URL}/dovemap?item_type=nfp&appName=${appName}&previous=${currentPath}&claim=true&next=${currentPath}`)
            break
          case "hcp":
            window.open(`${process.env.SSO_BASE_URL}/dovemed-sso/claim/ohcp/?next=${currentPath}`)
            break
        }
        this.isPageRouting = false
      }
      // this.ssoMultiLogin(payload);
    },

    postRole(payload) {
      AppRepository.postHasMultiRole(payload).then(res => {
        UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id).then(res => {
          console.log("I AM CALLING")
          console.log("this.selectedRole ==", this.selectedRole)
          this.authUser.user.first_post = res.data.data.user_info.first_post
          this.$store.state.User.user.user.role = this.selectedRole || res.data.data.user_info.role
          this.$store.state.User.user.user.display_name = res.data.data.user_info.display_name ? res.data.data.user_info.display_name : "D"
          this.$router.push(`/${this.currentCircle.key_name}/home/activity`)
          const userData = {
            user: {
              ...this.authUser.user,
              // circles: [...this.authUser.user.circles, this.currentCircle],
              circles: this.authUser.user.circles && this.authUser.user.circles.length ? [...this.authUser.user.circles, this.currentCircle] : [this.currentCircle],
              multiRole: [...this.authUser.user.multiRole, { role: this.selectedRole.role, circle_id: this.currentCircle.id }],
              role: this.selectedRole.role,
            },
          }
          if (this.selectedRole.enter === false) {
            console.log("commiting new data to local storage")
            this.$store.commit("User/setUser", { data: userData }, { root: true })
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.vert-divider2 {
  display: none;
  @media screen and (max-width: 660px) {
    height: 100%;
    position: absolute;
    border: 1px solid #e2e8f0;
    margin-top: -16px;
    background: #e2e8f0;
    margin-left: 80.5px;
    display: flex;
  }
}

.vert-divider {
  display: none;
  @media screen and (max-width: 660px) {
    height: 100%;
    position: absolute;
    border: 1px solid #e2e8f0;
    margin-top: -16px;
    background: #e2e8f0;
    margin-left: 80.5px;
    display: flex;
  }
}

.btn-container {
  @media screen and (max-width: 900px) {
    margin-left: 95px;
    width: 209px;
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
}

.join-button {
  // border: 1px solid #062b54 !important;
  background: #2a71d4;
  color: #ffffff !important;
  @media screen and (max-width: 660px) {
    width: 100%;
  }
}

.enter-button {
  // border: 1px solid #062b54 !important;
  background: #062b54;
  color: #ffffff !important;
  @media screen and (max-width: 660px) {
    width: 60%;
  }
}
.inner-title-container {
  gap: 0px;
  display: flex;
  flex-direction: column;
}

.main-container {
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 660px) {
    margin: 10px;
  }
}
.blue-text {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #2a71d4;
  text-transform: capitalize;
  min-width: max-content;
  @media screen and (max-width: 660px) {
    min-width: 0px;
  }
}

.yellow-text {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #f5a623;
  text-transform: capitalize;
  min-width: max-content;
  @media screen and (max-width: 660px) {
    min-width: 0px;
  }
}

.physician-tag {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  // width: 113px;
  // height: 32px;
  background: #fff0d6;
  border-radius: 4px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #f5a623;
  @media screen and (max-width: 900px) {
    display: none;
  }
}

.physician-tag-mob {
  display: none;
  @media screen and (max-width: 900px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 4px 8px;
    gap: 4px;
    // width: 113px;
    // height: 32px;
    width: fit-content;
    background: #fff0d6;
    border-radius: 4px;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #f5a623;
  }
}

.patient-tag-mob {
  display: none;
  @media screen and (max-width: 660px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 4px 8px;
    gap: 4px;
    height: 32px;
    background: #e1eaf7;
    border-radius: 4px;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #2a71d4;
    width: fit-content;
  }
}

.patient-tag {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  height: 32px;
  background: #e1eaf7;
  border-radius: 4px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #2a71d4;
  @media screen and (max-width: 660px) {
    display: none;
  }
}
.tag-icon-blue {
  height: 17.5px;
  width: 20px;
  color: #2a71d4;
}
.tag-icon-oran {
  height: 17.5px;
  width: 20px;
  color: #f5a623;
}

.text-container1 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
  @media screen and (max-width: 660px) {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    gap: 16px;
    margin-bottom: 32px;
  }
}
.tag {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  width: 97px;
  height: 32px;
  background: #e1eaf7;
  border-radius: 4px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #2a71d4;
}
.Enterbtn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  width: 131px;
  height: 48px;
  background: #062b54;
  border-radius: 6px;
  border: none;
}
.claim-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 36px;
  background: #2a71d4;
  border-radius: 6px;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  width: 122px;
}

.btn {
  padding: 8px 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 48px;
  background: #2a71d4;
  border-radius: 6px;
  border: none;
  color: #ffffff;
  cursor: pointer;
}

.question-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.text {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
  @media screen and (max-width: 660px) {
    // text-align: center;
    width: 163px;
  }
}

.text-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  //  height: 30px;
  @media screen and (max-width: 660px) {
    display: flex;
    // flex-direction: column;
    align-items: flex-start;
    margin-bottom: 32px;
  }
}

.icon {
  width: 70px;
  height: 70px;
}

.right-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  width: 100%;
  max-width: 581px;
  // height: 70px;
  @media screen and (max-width: 660px) {
    display: flex;
    align-items: flex-start;
    gap: 30px;
  }
}

.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 63px;
  width: 100%;
  max-width: 758px;
  //  height: 70px;

  @media screen and (max-width: 660px) {
    display: flex;
    flex-direction: column;
    gap: 0px;
    align-items: flex-start;
  }
}

.divider-mob {
  display: none;
  @media screen and (max-width: 660px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
    gap: 16px;
    margin: 48px;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    color: #1e2945;
  }
}

.sub-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 10px;
  width: 100%;
  // width: 790px;
  // height: 102px;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(60, 60, 60, 0.1);
  border-radius: 4px;
  @media screen and (max-width: 660px) {
    position: relative;
  }
}

.divider {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 16px;
  margin: 48px;
  //  width: 475px;
  //  height: 32px;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: #1e2945;
  //  position: absolute;
  //  top: 686px;
  //  left:482.5px;
  @media screen and (max-width: 660px) {
    display: none;
  }
}

.claim-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  width: 100%;
  max-width: 790px;
  //  height: 574px;
  //  position: absolute;
  //  top: 766px;
  //  left: 325px;
}

.claimed-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  width: 100%;
  max-width: 790px;
  //  height: 338px;
  //  position: absolute;
  //  top:300px;
  //  left:325px;
}
.instruction {
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  text-align: center;
  color: #647490;
  margin-bottom: 48px;
}
.title {
  // width:522px;
  font-weight: 700;
  font-size: 36px;
  line-height: 46px;
  text-align: center;
  color: #1e2945;
  text-align: center;
}
.title-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  margin-bottom: 16px;
  width: 100%;
  max-width: 522px;
  //  position: absolute;
  //  top:112px;
  //  left:459px;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/SignupUserType.vue